export const ADMONITION_START_REGEX = /^!!!\s*(note|info|tip|question|danger|warning)\s*"([^"]*)"\s*$/;
export const ADMONITION_END_REGEX = /^!!!$/;
export const DEFAULT_TABLE_ROW_HEIGHT = 39;
export const EMOJI_REGEX = /:([a-z0-9_]+):/;
export const EXTENDED_TEXT_REGEX = /.*/;
export const HR_REGEX = /^(---|\*\*\*|___)\s?$/;
export const IMAGE_IMPORT_REGEX = /!(?:\[([^[]*)\])(?:\(([^(]+)\))(?:\{width: (inherit|\d+)\})?/;
export const IMAGE_REPLACE_REG_EXP = /!(?:\[([^[]*)\])(?:\(([^(]+)\))$/;
export const TABLE_REG_EXP = /^(?:(?:\|)(.+)(?:\|)\s?|\[colWidths=\s*([^\]]+)\])$/;
